export const headerLocalization = {
  bankLabel: {
    en: 'Online Banking',
    nb: 'Nettbank',
    nn: 'Nettbank',
  },
  myTasksLink: {
    en: 'My tasks',
    nb: 'Mine gjøremål',
    nn: 'Mine gjøremål',
  },
  myApplicationsLink: {
    en: 'My applications and inquiries',
    nb: 'Mine søknader og henvendelser',
    nn: 'Mine søknader og førespurnader',
  },
  myProfileLink: {
    en: 'My profile',
    nb: 'Min profil',
    nn: 'Min profil',
  },
  logOutLabel: {
    en: 'Log out',
    nb: 'Logg ut',
    nn: 'Logg ut',
  },
} as const;
